// extracted by mini-css-extract-plugin
var _1 = "URpqzglnp5O_TMmLTqP6";
var _2 = "BvFTOJeu8ifdM7D8WucA";
export { _1 as "container", _2 as "grid" }
